import { GiphyFetch } from '@giphy/js-fetch-api';
import { IGif } from '@giphy/js-types';
import { SyntheticEvent, useEffect, useState } from 'react';

import Preview from '../../Preview';
import withControl, { WithControlRenderProps } from '../withControl';

import Results from './Results';
import Searchbar from './Searchbar';
import { giphyClassName } from './styles';
import { GiphyProps } from './types';

type Props = GiphyProps & WithControlRenderProps;

const Giphy = ({ toFormValue, onChange, fromFormValue, ref, value }: Props) => {
  const [gif, setGif] = useState<IGif | undefined>(undefined);
  const [search, setSearch] = useState<string>('');
  const gifId = fromFormValue(value);

  const handleClick = (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => {
    e.preventDefault();
    setGif(gif);
    onChange(toFormValue(String(gif.id)));
  };

  const handleReset = () => {
    setGif(undefined);
    onChange(null); // use null since undefined defaults to DEFAULT_VALUE
  };

  useEffect(() => {
    const fetchGif = async (id: string) => {
      const gf = new GiphyFetch(process.env.REACT_APP_GIPHY_API_KEY!);
      const { data } = await gf.gif(id);
      setGif(data);
    };
    if (!!gifId) {
      if (!gif) {
        fetchGif(gifId);
      }
    } else {
      setGif(undefined);
    }
  }, []); // eslint-disable-line

  return (
    <div className={giphyClassName} ref={ref}>
      {gif ? (
        <Preview gif={gif} onReset={handleReset} />
      ) : (
        <>
          <Searchbar search={search} setSearch={setSearch} />
          <Results search={search} handleClick={handleClick} />
        </>
      )}
    </div>
  );
};

Giphy.displayName = 'Giphy';

export default withControl(Giphy);
